export enum PageNameTypes {
  Category = 'Category',
  SearchResults = 'Search Results',
  BrandPlp = 'Brand PLP',
  LandingPage = 'Content Landing Page',
  HubPage = 'Content Hub Page',
  CustomPLP = 'Custom PLP',
  ProductPage = 'Product Page',
  SearchSuggestions = 'Search Suggestions',
  PromotionAlternativeProducts = 'Promotion Alternative Products',
  ExpandedSearchAlternativeProducts = 'Expanded Search Alternative Products',
  CategoryAlternativeProducts = 'Category Alternative Products',
  FilterAlternativeProducts = 'Filter Alternative Products',
  SimilarProducts = 'Similar Products',
  MostPopularProducts = 'Most Popular Products',
  MostRelevantProducts = 'Popular products recommendation',
  ParsedTextProducts = 'Parsed text products recommendation',
  CustomHubPageMostPopularProducts = 'Custom Hub Page Most Popular Products',
  CustomHubPageLatestDealsProducts = 'Custom Hub Page Latest Deals Products',
}
